<template>
    <div>
        <el-form-item :label="field.name + '：'" label-width="110px" id="image-list">
            <el-radio-group v-model="config[field.key]">
                <span v-for="item in radioList" class="radio-item">
                    <el-radio :label="item.value">{{item.label}}</el-radio>
                </span>
            </el-radio-group>
            <el-input clearable :placeholder="placeholder" v-model="config['contact_info']"></el-input>
        </el-form-item>
    </div>
</template>

<style lang="scss">
    .radio-item{
        padding-right: 20px;
    }
</style>

<script>

  export default {
    name: 'tms-type-customer-service',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      config: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        radioList: [{
          label: "微信客服",
          value: 1
        }, {
          label: "电话号码",
          value: 2
        }]
      }
    },

    computed: {
      placeholder() {
        if(this.config[this.field.key] === 1){
          return '请输入微信客服';
        }else{
          return '请输入电话号码';
        }
      }
    },

    components: {},

    mounted() {

    },

    methods: {
    }
  }

</script>
